module.exports = __webpack_public_path__ + "static/media/team-member-2.4ef97c89.jpeg";